import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import {
  Heading2,
  Label,
  LeftHalfLayout,
  RightHalfLayout,
  Flex,
  Panel,
  TextInput
} from '@sopranodesign/pulse-components';
import { TopSection } from '@sopranodesign/pulse-tickets';

import JsonPreview from '../JsonPreview';
import { getName } from '../LogName';
import LogLevel from '../LogLevel';
import LogDescription from '../LogDescription';

const McpSkillContent = ({
  subscriber,
  created_at,
  description,
  content,
  level,
  type
}) => (
  <Panel>
    <Flex col mb>
      <TopSection center>
        <LogLevel level={level} />
        <Heading2>{getName({ level, type })}</Heading2>
      </TopSection>
      <Label secondary>
        {dayjs(created_at).from(dayjs())} by{' '}
        {subscriber ? `Subscriber #${subscriber.id}` : 'N/A'}
      </Label>
    </Flex>
    <Flex>
      {!content ? (
        <LogDescription description={description} />
      ) : (
        <>
          <LeftHalfLayout>
            <LogDescription description={description} />
          </LeftHalfLayout>
          <RightHalfLayout>
            <div>
              <Label>Skill</Label>
              <TextInput value={content.skill ?? 'N/A'} disabled />
            </div>
            <div>
              <Label>Provider</Label>
              <TextInput value={content.provider ?? 'N/A'} disabled />
            </div>
            <div>
              <Label>Latency</Label>
              <TextInput value={`${content.latency_ms ?? 0}ms`} disabled />
            </div>
            {content.error ? (
              <div>
                <Label>Error</Label>
                <TextInput value={content.error} disabled />
              </div>
            ) : null}
            {content.input ? (
              <div>
                <Label>Input</Label>
                <JsonPreview value={content.input} />
              </div>
            ) : null}
            {content.output ? (
              <div>
                <Label>Output</Label>
                <JsonPreview value={content.output} />
              </div>
            ) : null}
          </RightHalfLayout>
        </>
      )}
    </Flex>
  </Panel>
);

McpSkillContent.propTypes = {
  subscriber: PropTypes.shape({
    id: PropTypes.number
  }),
  created_at: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.shape({
    skill: PropTypes.string,
    provider: PropTypes.string,
    status: PropTypes.string,
    latency_ms: PropTypes.number,
    error: PropTypes.string,
    input: PropTypes.object,
    output: PropTypes.object
  })
};

export default McpSkillContent;
